import TwoFAHelp from './TwoFAHelp';

export default TwoFAHelp;
